<template>
  <template v-if="error">
    存在しない歌碑ID
  </template>
  <template v-else-if="detail">
    <div class="kahiDetailPhoto">
      <div>
        <div>
          <kahi-photo
            v-bind:image="detail.image"
            v-bind:image-load="true"
            v-bind:spinner-size="'5px'"
          ></kahi-photo>
        </div>
      </div>
    </div>
    <div class="kahiDetailBody">
      <h2
        class="kahiDetailBodyUta"
        v-html="breakLineUta(detail.uta1, 3, 7)"
      ></h2>
      <kahi-meta-info
        v-bind:display-type="'detail'"
        v-bind:saku="detail.saku1"
        v-bind:volume="detail.volume"
        v-bind:kno="detail.kno1"
      ></kahi-meta-info>
      <dl>
        <dt>所在地</dt>
        <dd>
          <div>{{ detail.shozaichi }}</div>
          <div class="kahiDetailBodyLocation">
            <div class="mapLinkButton">
              <router-link
                v-bind:to="{ name: 'KahiMap', params: { mapId: detail.KID } }"
                ><img src="/images/detail_btn_map.svg" alt="地図でみる"
              /></router-link>
            </div>
            <div>
              現在地から<span>{{ convertDistance(distance) }}</span>
            </div>
          </div>
        </dd>
        <dt>揮毫者</dt>
        <dd>{{ detail.kigou }}</dd>
      </dl>
      <h3>解説</h3>
      <div
        class="kahiDetailBodyKaisetsu"
        v-html="convertParagraph(detail.kaisetsu)"
      ></div>
    </div>
    <div class="kahiDetailRelation" v-if="detail.relation !== null">
      <h4>反歌・返歌</h4>
      <template v-if="detail.relation.links.length > 0">
        <ul>
          <li v-for="kahi in detail.relation.links" v-bind:key="kahi.KID">
            <router-link
              v-bind:to="{ name: 'KahiDetail', params: { detailId: kahi.KID } }"
            >
              <kahi-detail-relation
                v-bind:kahi="detail.relation"
                v-bind:is-link="true"
                v-bind:coords="kahi.coords"
              ></kahi-detail-relation>
            </router-link>
          </li>
        </ul>
      </template>
      <template v-else>
        <kahi-detail-relation
          v-bind:kahi="detail.relation"
          v-bind:is-link="false"
        ></kahi-detail-relation>
      </template>
    </div>
  </template>
</template>

<script lang="ts" src="./AsyncKahiDetail.ts"></script>
<style scoped lang="scss" src="./AsyncKahiDetail.scss"></style>
